export const textareaTrim = (v: string) => {
  return v
    .trim()
    .split('\n') // 줄 나누고
    .map((line) => line.trim()) // 각 줄의 앞뒤 공백 제거
    .join('\n'); // 남은 줄 합치고;
};
